
<template>
  <span>

    <a href="#" class="btn skin primary-button" @click="openModal" style="color:inherit;">browse pexels</a>

    <modal-in-front v-bind:title="map" ref="thisModal" size="modal-md">
      <div style="margin:auto;overflow:visible;position:relative">
        <div class="container-fluid">
          <div class="row">
            <div class="col-10 col-md-6">
              <input v-model="tag"
                     placeholder="Search for photos"
                     type="text"
                     class="form-control">
            </div>
            <div class="col-2">
              <button type="submit"
                      class="btn btn-success"
                      @click.prevent="search">
                Go
              </button>
            </div>
            <div class="col-4 mt-3 mt-md-0">
              <select class="form-control" v-model="size">
                <option value="landscape" selected>landscape</option>
                <option value="portrait">portrait</option>
                <option value="square">square</option>
              </select>
            </div>
            <div class="col-12">

              <div class="wrapper" style="max-height:400px;overflow-y:scroll;">
                <p v-if="loading" class="text-centered">
                  Loading...
                </p>
                <ul v-else class="image-card-grid">
                  <image-card @onclicked="onclicked" v-for="image in images"
                              :key="image.id"
                              :image="image" />
                </ul>
              </div>
            </div>
          </div>

          </div>
        </div>
        </modal-in-front>
  </span>

</template>

<script>

  import ModalInFront from "../modals/modal-in-front.vue";
  import axios from 'axios';
  let jsonpAdapter = require('axios-jsonp');
  import ImageCard from "../imagehandling/Image-Card";
  
  export default {
    name: 'pexels-button',
    components: {
      ModalInFront,
      ImageCard
    },
    props: {
      
    },
    data() {
      return {
        api_key: "563492ad6f9170000100000195019ab8fe234eb5bbb68662dd10bd9e",
        loading: false,
        tag: '',
        images: [],
        infoIconUrl : "https://developers.google.com/maps/documentation/javascript/examples/full/images/info-i_maps.png",
        jsonpAdapter,
        size: 'landscape'
      }
    },
    methods: {
      onclicked(image) {
        this.$emit("onclicked", image);
        this.$refs.thisModal.close();
      },
      openModal() {
        this.$refs.thisModal.open();
      },
      getId() {
        return this._uid;
      },
      search() {
        this.loading = true;
        this.fetchImages();
      },

      displayImages(response) {
        this.images = response.photos.photo;
        this.loading = false;
      },
      async fetchImages_not_working() {
        //https://api.pexels.com/v1/search?
        //url: "https://api.pexels.com/v1/curated?per_page=11&page=1",

        const {
          data: { photos }
        } = await axios({
          url: "https://api.pexels.com/v1/search?query=" + tag + "&per_page=11&page=1",
          headers: {
            Authorization: this.api_key
          }
        });
        alert("axios:" + JSON.stringify(photos[0]));
      },
      async fetchImages() {
        const headers = new Headers();
        headers.append(
          "Authorization",
          this.api_key
        );
        const request = new Request(
          "https://api.pexels.com/v1/search?query=" + this.tag + "&per_page=11&page=1",
          {
            method: "GET",
            headers,
            mode: "cors",
            cache: "default"
          }
        );
        const res = await fetch(request);
        const { photos } = await res.json();

        var tmpPhotos = [];
        for (var i = 0; i < photos.length; i++) {
          var u = photos[i].src.medium;
          if (this.size == "landscape") {
            u = photos[i].src.landscape;
          }
          else if (this.size == "portrait")
          {
            u = photos[i].src.portrait;
          }
          if (u == "" || u == null || typeof (u) == "undefined")
          {
            u = photos[i].src.medium;
          }

          tmpPhotos.push(
            {
              "title": photos[i].id,
              "ownername": photos[i].photographer,
              "datetaken": "",
              "views": "",
              "url_n": u,
            }
          )
        }
        this.images = tmpPhotos;
        this.loading = false;

      },
      fetchImages2() {

        var instance = axios.create({
          timeout: 1000,
          headers: { 'Authorization': this.api_key }
        });

        instance.get("https://api.pexels.com/v1/search",
          {
            adapter: jsonpAdapter,
            callbackParamName: 'c', // optional, 'callback' by default
            params: {
              query: this.tag,
            }
          }
        ).then((response) => {

          var tmpPhotos = [];
          for (var i = 0; i < response.data.photos.length; i++) {
            tmpPhotos.push(
              {
                "title": response.data.photos[i].alt,
                "ownername": response.data.photos[i].photographer,
                "datetaken":"",
                "views":"",
                "url_n": response.data.photos[i].url,
              }
            )
          }

          this.images = tmpPhotos;
          this.loading = false;
        });
      },
    },
    created() {

    },
    mounted() {
      window.jsonFlickrApi = this.displayImages;
    }
  }
</script>



<style scoped>


  .image-card-grid {
    list-style: none;
    margin: .5rem 0;
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/imagehandling/pexels-button.vue